import React from "react";
import {
  FaWifi,
  FaSwimmingPool,
  FaConciergeBell,
  FaCar,
  FaDumbbell,
  FaUtensils,
  FaGlassCheers,
  FaCalendarAlt,
  FaSpa,
  FaBuilding,
  FaSnowflake,
  FaShower,
  FaHotTub,
  FaCoffee,
  FaHandsHelping,
  FaGlassMartiniAlt,
  FaUmbrellaBeach,
} from "react-icons/fa";
import poolBg from "../../assets/hotel_amenities/guzape_pool2.jpg";
import gymBg from "../../assets/hotel_amenities/lekki_phase1_gym.JPEG";
import lobbyBg from "../../assets/hotel_amenities/lekki_phase1_lobby.JPEG";
import "./Amenities.css";

const iconMap = {
  "swimming pool": FaSwimmingPool,
  "pool": FaSwimmingPool,
  "free wifi": FaWifi,
  "wifi": FaWifi,
  "internet": FaWifi,
  "restaurant": FaUtensils,
  "dining": FaUtensils,
  "bar": FaGlassCheers,
  "exclusive bar": FaGlassCheers,
  "lounge": FaGlassCheers,
  "front desk": FaConciergeBell,
  "24-hour front desk": FaConciergeBell,
  "concierge": FaConciergeBell,
  "fitness": FaDumbbell,
  "fitness center": FaDumbbell,
  "gym": FaDumbbell,
  "parking": FaCar,
  "free parking": FaCar,
  "event": FaCalendarAlt,
  "event center": FaCalendarAlt,
  "conference": FaCalendarAlt,
  "spa": FaSpa,
  "wellness": FaSpa,
  "banquet": FaBuilding,
  "hall": FaBuilding,
  "air conditioning": FaSnowflake,
  "ac": FaSnowflake,
  "shower": FaShower,
  "hot tub": FaHotTub,
  "jacuzzi": FaHotTub,
  "coffee": FaCoffee,
  "room service": FaConciergeBell,
  "laundry": FaHandsHelping,
  "lounge bar": FaGlassMartiniAlt,
  "beach": FaUmbrellaBeach,
  "garden": FaUmbrellaBeach,
};

const fallbackAmenities = [
  { name: "Swimming Pool", desc: "Dive into our refreshing pool and unwind after a long day.", size: "lg", accent: "blue", bgImage: poolBg },
  { name: "Free Wi-Fi", desc: "Complimentary high-speed internet throughout your stay.", size: "sm", accent: "purple" },
  { name: "Restaurant", desc: "Savor local and international cuisine crafted by our expert chefs.", size: "sm", accent: "gold" },
  { name: "Exclusive Bar", desc: "Handcrafted cocktails and premium spirits.", size: "md", accent: "dark" },
  { name: "24-Hour Front Desk", desc: "Our attentive staff is available around the clock.", size: "sm", accent: "image", bgImage: lobbyBg },
  { name: "Fitness Center", desc: "Maintain your workout routine in our fully equipped gym.", size: "md", accent: "image", bgImage: gymBg },
  { name: "Free Parking", desc: "Complimentary parking for all hotel guests.", size: "sm", accent: "gold" },
  { name: "Event Center", desc: "Host seminars, conferences, and weddings in our premium event halls.", size: "sm", accent: "dark" },
];

const accentClasses = ["blue", "purple", "gold", "dark", "image"];

const getIcon = (name) => {
  const lower = (name || "").toLowerCase();
  for (const [key, Icon] of Object.entries(iconMap)) {
    if (lower.includes(key)) return Icon;
  }
  return FaConciergeBell;
};

const getBgImage = (name) => {
  const lower = (name || "").toLowerCase();
  if (lower.includes("pool") || lower.includes("swimming")) return poolBg;
  if (lower.includes("gym") || lower.includes("fitness")) return gymBg;
  if (lower.includes("lobby") || lower.includes("front desk")) return lobbyBg;
  return null;
};

const Amenities = ({ hotelName, amenities: hotelAmenities }) => {
  const hasAmenities = hotelAmenities && hotelAmenities.length > 0;

  const items = hasAmenities
    ? hotelAmenities.map((item, index) => {
        const name = typeof item === "string" ? item : item.amenity || item.name || item;
        const bgImage = getBgImage(name);
        return {
          icon: getIcon(name),
          name,
          desc: `Enjoy ${name.toLowerCase()} at ${hotelName || "this hotel"}.`,
          accent: bgImage ? "image" : accentClasses[index % accentClasses.length],
          bgImage,
        };
      })
    : fallbackAmenities.map((item) => ({
        ...item,
        icon: getIcon(item.name),
      }));

  return (
    <section className="amenities">
      <div className="amenities__container">
        <div className="amenities__header">
          <span className="amenities__label">Amenities</span>
          <h2 className="amenities__heading">
            {hotelName || "Residency"}{" "}
            <span className="amenities__heading-accent">Amenities</span>
          </h2>
          <div className="amenities__divider" />
          <p className="amenities__desc">
            Take a look at some of the special amenities you can enjoy at{" "}
            {hotelName ? `the ${hotelName}` : "any Residency hotel near you"}.
          </p>
        </div>

        <div className="amenities__bento">
          {items.map((item) => {
            const Icon = item.icon;
            return (
              <div
                className={`amenities__card amenities__card--${item.accent}`}
                key={item.name}
                style={
                  item.bgImage
                    ? { backgroundImage: `url(${item.bgImage})` }
                    : undefined
                }
              >
                {item.bgImage && <div className="amenities__card-overlay" />}
                <div className="amenities__card-ring" />
                <div className="amenities__card-icon">
                  <Icon />
                </div>
                <h3 className="amenities__card-name">{item.name}</h3>
                <p className="amenities__card-desc">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Amenities;
